module.exports = __webpack_public_path__ + "static/media/alexandretonnelier.bf32fdd6.jpg";